export default "__VITE_ASSET__jT2DbAAk__"